import appStyles from '../../../App.module.css';
const Spinner = () => {
    return (
        <div className={appStyles.bfSpinnerOverlay}>
            <div className={appStyles.bfSpinner}></div>
        </div>
    )
}

export default Spinner;